import React, { useState, useRef, useEffect } from 'react'
import styled from 'styled-components'
import Settings from "../components/Settings"
import Menu from '../components/Menu'
import { ResizeObserver } from 'resize-observer';
import { useDarkModeManager } from '../state/user/hooks';
import greenTopLeftFlower from "../assets/images/Top.png";
import topRightImage from "../assets/images/coraltop.png";
import leftBottomImage from "../assets/images/coralbottom.png";
import bottomRightCoral from "../assets/images/purplecoral.png";
import rightBottomFlower from "../assets/images/grassbottom.png";
export const BodyWrapper = styled.div`
position: relative;
overflow:visible;
max-width: 420px;
width: 100%;
// opacity: 0.6;
// background green;
background: ${({ theme }) => theme.bg1};
box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.01), 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 16px 24px rgba(0, 0, 0, 0.04),
  0px 24px 32px rgba(0, 0, 0, 0.01);
border-radius: 30px;
padding: 13px;
// padding: 1rem;
// margin: 64px auto;
  // position: relative;
  // max-width: 420px;
  // width: 100%;
  // background: ${({ theme }) => theme.bg1};
  // box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.01), 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 16px 24px rgba(0, 0, 0, 0.04),
  //   0px 24px 32px rgba(0, 0, 0, 0.01);
  // border-radius: 30px;
  // padding: 1rem;
  ${({ theme }) => `
  max-width:380px;
  background:none;
  box-shadow:none;
  // box-shadow:inset 0px 0px 200px rgba(0,0,0,1);
  `}
`

const AppContainer = styled.div`
position:relative;
max-width: 420px;
width:100%;
transform:scale(.8);
margin-top:-60px;

${({ theme }) => `
// padding:100px 80px 140px 100px;
padding:160px 40px 220px 80px;
display:flex;
flex-direction:column;
align-items:center;
-webkit-align-items: center;
 -webkit-box-align: center;
 -ms-flex-align: center;
overflow:visible;
max-width:560px;
@media(max-width:750px){
margin-top:0px;
padding:120px 40px 160px 80px;
}

`}
`
const SettingsWrapper = styled.div`
position:absolute;
left:50%;
bottom:55px;
transform:translateX(-25%);
z-index:1;
`
const MenuWrapper = styled.div`
position:absolute;
left:50%;
top:70px;
transform:translateX(-35%);
z-index:1;
`

const Svg = styled.svg<{ color: string, smallShadow?: boolean }>`
filter: 
drop-shadow(0 0px 2px #fff) 
drop-shadow(0 0px 2px ${({ color }) => color})
drop-shadow(0 0px 2px ${({ color }) => color})
drop-shadow(0 0px 2px ${({ color }) => color});
 
${({ smallShadow, color }) => smallShadow && `
filter: 
drop-shadow(0 0px 1px #fff) 
drop-shadow(0 0px 1px ${color})
drop-shadow(0 0px 1px ${color})
drop-shadow(0 0px 1px ${color});
`}

position:absolute;
left:0;
right:0;
bottom:0;
`
const TopLeftFlower = styled.img`
position:absolute;
width:150px;
left:-10px;
top:0;
transform:translateY(-140%) rotate(7deg);
`

const RightTopImage = styled.img`
position:absolute;
width:150px;
right:-20px;
top:0;
transform:translateY(-160%) ;
`
const LeftBottomImage = styled.img`
position:absolute;
width:130px;
left:20px;
bottom:0;
z-index:1;
transform:translateY(100%) ;
`
const RightBottomCoral = styled.img`
position:absolute;
width:110px;
right:20px;
bottom:0;
z-index:100;
transform:translateY(115%) ;
`
const RightBottomFlower = styled.img`
position:absolute;
width:60px;
right:100px;
bottom:0;
z-index:100;
transform:translateY(115%) ;
`
const BGImage = ({ parentRef }: { parentRef: any }) => {
  const [path, setPath] = useState<string[]>([]);
  const [circles, setCircles] = useState<{ x: number, y: number }[]>([]);
  const svg = useRef<any>();
  const svg2 = useRef<any>();
  const svg3 = useRef<any>();
  const removePX = (value: string) => Number(value.replace("px", ""));
  const observer = new ResizeObserver(drawImage)
  useEffect(() => {

  }, [])
  useEffect(() => {
    window.addEventListener("resize", drawImage);

    observer.observe(parentRef.current)
    return () => {
      window.removeEventListener("resize", drawImage);
      if (parentRef.current)
        observer.unobserve(parentRef.current)

    }
  }, [parentRef, svg, svg2, svg3])
  function drawImage() {
    if (parentRef !== null && parentRef.current && svg.current && svg2.current) {
      var paths = [], path = "", circles = [];
      const div: HTMLElement = parentRef.current,
        svgEl: any = svg.current,
        svg2El: any = svg2.current,
        svg3El: any = svg3.current,
        diff = 14;
      let height = div.offsetHeight,
        width = div.offsetWidth,
        style = window.getComputedStyle(div),
        left = removePX(style.paddingLeft) - removePX(style.paddingRight),
        right = width - removePX(style.paddingRight) / 2.4 + diff,
        top = diff,
        bottom = height - diff;
      let curveDiff = 20;
      svgEl.style.width = width.toString();
      svgEl.style.height = height.toString();
      svg2El.style.width = width.toString();
      svg2El.style.height = height.toString();
      svg3El.style.width = width.toString();
      svg3El.style.height = height.toString();
      let xGrid = 17,
        GridWidthX = (right - left) / xGrid,
        topGrid = 6,
        topGridY = (removePX(style.paddingTop) - diff) / topGrid,
        bottomGrid = 11,
        bottomGridY = removePX(style.paddingBottom) / bottomGrid,
        subGridY =
          (bottom - bottomGridY * (bottomGrid - 1) - (top + topGridY * 2)) / 8;

      let x = right - GridWidthX * 5,
        y = top + topGridY * 2;
      path += `M ${x} ${y}`;
      y = top + topGridY * (topGrid - 1);
      path += ` Q ${right} ${top + topGridY * 3} ${right} ${y}`;
      x = right;
      y = bottom - bottomGridY * (bottomGrid - 1);
      path += ` L ${x} ${y}`;
      x = right - GridWidthX * 3;
      path += ` Q ${right} ${y + bottomGridY * 2} ${x} ${y + bottomGridY * 3}`;
      x = x - GridWidthX;
      y = y + bottomGridY * 3;
      path += ` Q ${x} ${y} ${x} ${y + bottomGridY}`;
      y = y + bottomGridY * 3;
      path += ` L ${x} ${y}`;
      x = x - GridWidthX;
      y = y + bottomGridY;
      path += ` Q ${x + GridWidthX} ${y} ${x} ${y}`;
      x = x - GridWidthX * 2;
      path += ` H ${x}`;
      path += ` C ${x} ${bottom - bottomGridY + diff} ${x - GridWidthX * 3} ${bottom - bottomGridY + diff
        } ${x - GridWidthX * 3} ${y}`;
      x = x - GridWidthX * 5;
      path += ` H ${x}`;
      x = x - GridWidthX;
      path += ` Q ${x} ${y} ${x} ${y - bottomGridY}`;
      y = y - bottomGridY * 3;
      path += ` L ${x} ${y}`;
      x = x - GridWidthX;
      y = y - bottomGridY;
      path += ` Q ${x + GridWidthX} ${y} ${x} ${y}`;
      x = x - GridWidthX * 3;
      y = bottom - bottomGridY * (bottomGrid - 2);
      path += ` Q ${x} ${y + bottomGridY} ${x} ${y}`;
      y = y - subGridY;
      path += ` L ${x} ${y}`;
      y = y - subGridY;
      circles.push({ x: diff * 2.4, y: y + subGridY / 2 });
      path += ` C ${diff / 2} ${y + subGridY} ${diff / 2} ${y} ${left} ${y}`;
      x = left;
      y = y - subGridY;
      path += ` L ${x} ${y}`;
      y = y - subGridY;
      circles.push({ x: diff * 2.4, y: y + subGridY / 2 });

      path += ` C ${diff / 2} ${y + subGridY} ${diff / 2} ${y} ${left} ${y}`;
      x = left;
      y = y - subGridY;
      path += ` L ${x} ${y}`;
      y = y - subGridY;
      circles.push({ x: diff * 2.4, y: y + subGridY / 2 });

      path += ` C ${diff / 2} ${y + subGridY} ${diff / 2} ${y} ${left} ${y}`;
      y = top + topGridY * (topGrid - 1);
      x = left;
      path += ` L ${x} ${y}`;
      y = top + topGridY * 3;
      x = left + GridWidthX * 5;
      path += ` Q ${left} ${y} ${x} ${y - topGridY}`;
      y = y - topGridY;
      path += ` C ${x} ${top - diff * 1.5} ${x + GridWidthX * 7} ${top - diff * 1.5
        } ${x + GridWidthX * 7} ${y}`;
      setCircles(circles)
      paths.push(path)

      //small path
      //adding small path
      //small path
      //adding small path
      path = "";
      y = bottom - bottomGridY * 8 + curveDiff;
      x = right - GridWidthX * 4 - curveDiff;
      path = ` M ${x - curveDiff} ${y + 5}`;
      path += ` Q ${x} ${y} ${x} ${y + bottomGridY / 2}`;
      y += bottomGridY * 3 - diff;
      path += ` L ${x} ${y}`;
      y = y + bottomGridY;
      path += ` Q ${x} ${y} ${x - curveDiff} ${y}`;
      x = x - GridWidthX * 3 + curveDiff;
      path += ` H ${x}`;
      path += ` C ${x} ${y - bottomGridY * 3 + diff} ${x - GridWidthX * 3} ${y - bottomGridY * 3 + diff
        } ${x - GridWidthX * 3} ${y}`;
      x = left + GridWidthX * 4 + curveDiff * 2;
      path += ` H ${x}`;
      path += ` Q ${x - curveDiff} ${y} ${x - curveDiff} ${y - bottomGridY}`;
      y = y - bottomGridY * 3;
      x = x - curveDiff;
      path += ` L ${x} ${y}`;
      y = bottom - bottomGridY * 8 + curveDiff;
      path += ` Q ${x} ${y} ${x + curveDiff} ${y + 5}`;
      x = x + GridWidthX * 3.5;
      path += ` Q ${x} ${y + bottomGridY * 2} ${right - GridWidthX * 4 - curveDiff * 2} ${y + 5
        }`;

      paths.push(path);

      //2nd path
      path = "";
      top = top + curveDiff;
      bottom = bottom - curveDiff;
      left = left + curveDiff;
      right = right - curveDiff;
      GridWidthX = (right - left) / xGrid;
      bottomGridY = (removePX(style.paddingBottom) - curveDiff) / bottomGrid;
      topGridY = (removePX(style.paddingTop) - curveDiff - diff / 2) / topGrid;

      x = right - GridWidthX * 6.8;
      y = top + topGridY * 2;
      path += `M ${x} ${y}`;
      y = top + topGridY * (topGrid - 1);
      path += ` Q ${right} ${top + topGridY * 3} ${right} ${y}`;
      x = right;
      y = bottom - bottomGridY * (bottomGrid - 1);
      path += ` L ${x} ${y}`;
      x = right - GridWidthX * 3;
      path += ` C ${right - GridWidthX * 3} ${y + bottomGridY * 4} ${left + GridWidthX * 3
        } ${y + bottomGridY * 4} ${left} ${y}`;
      y = top + topGridY * (topGrid - 1);
      x = left;
      path += ` L ${x} ${y}`;
      y = top + topGridY * 3;
      x = left + GridWidthX * 6.8;
      path += ` Q ${left} ${y} ${x} ${y - topGridY}`;
      x = right - GridWidthX * 6.8;
      y = y - topGridY;
      path += ` C ${left + GridWidthX * 6.8} ${top - diff * 1.5} ${x} ${top - diff * 1.5
        } ${x} ${y}`;

      paths.push(path);

      //third path;

      path = "";
      top = top + curveDiff;
      bottom = bottom - curveDiff;
      left = left + curveDiff;
      right = right - curveDiff;
      GridWidthX = (right - left) / xGrid;
      bottomGridY = (removePX(style.paddingBottom) - curveDiff) / bottomGrid;
      topGridY = (removePX(style.paddingTop) - curveDiff - diff / 2) / topGrid;

      x = right - GridWidthX * 6.7;
      y = top + topGridY * 2;
      path += `M ${x} ${y}`;
      y = top + topGridY * (topGrid - 1);
      path += ` Q ${right} ${top + topGridY * 3} ${right} ${y}`;
      x = right;
      y = bottom - bottomGridY * (bottomGrid - 1);
      path += ` L ${x} ${y}`;
      x = right - GridWidthX * 3;
      path += ` C ${right - GridWidthX * 3} ${y + bottomGridY * 4} ${left + GridWidthX * 3
        } ${y + bottomGridY * 4} ${left} ${y}`;
      y = top + topGridY * (topGrid - 1);
      x = left;
      path += ` L ${x} ${y}`;
      y = top + topGridY * 3;
      x = left + GridWidthX * 6.7;
      path += ` Q ${left} ${y} ${x} ${y - topGridY}`;
      x = right - GridWidthX * 6.7;
      y = y - topGridY;
      path += ` C ${left + GridWidthX * 6.7} ${top + topGridY * (topGrid - 1)
        } ${x} ${top + topGridY * (topGrid - 1)} ${x} ${y}`;

      paths.push(path)

      //setting paths
      setPath(paths)

    }
  }
  const isDark = useDarkModeManager()[0]
  return (
    <>
      <Svg xmlns="http://www.w3.org/2000/svg" ref={svg} color={isDark ? "#f549f5" : "#f549f5"} >

        {path[0] &&
          <path d={path[0]} stroke={isDark ? "#e8ffff" : "#e8ffff"} strokeWidth=".7px" fill="none"></path>
        }
        {path[1] &&
          <path d={path[1]} stroke={isDark ? "#e8ffff" : "#e8ffff"} strokeWidth=".7px" fill="none"></path>
        }
        {path[3] &&
          <path d={path[3]} stroke={isDark ? "#e8ffff" : "#e8ffff"} strokeWidth=".7px" fill="none"></path>
        }

      </Svg>
      <Svg xmlns="http://www.w3.org/2000/svg" ref={svg2} color={"#f5e15d"}>
        {path[2] &&
          <path d={path[2]} stroke="#e8ffff" strokeWidth=".7px" fill="none"></path>
        }

      </Svg>
      {/* 87A0E0 */}
      <Svg xmlns="http://www.w3.org/2000/svg" ref={svg3} color={isDark ? "#FFF" : "#FFF"} smallShadow={true}  >
        {circles.map(circle => <circle key={circle.x + circle.y} cx={circle.x} cy={circle.y} r="5" fill="none" strokeWidth=".7px" stroke="#d9baba" ></circle>)}
      </Svg>
    </>

  )
}
/**
 * The styled container element that wraps the content of most pages and the tabs.
 */
export default function AppBody({ children }: { children: React.ReactNode }) {
  const containerRef = useRef<HTMLDivElement>(null);
  return <>
    <AppContainer ref={containerRef}>

      <>
        <BGImage parentRef={containerRef} />
      </>
      <BodyWrapper >
        <>
          <TopLeftFlower src={greenTopLeftFlower} alt="image" />
          <RightTopImage src={topRightImage} alt=" flower image" />
          <LeftBottomImage src={leftBottomImage} alt="flower left" />
          <RightBottomCoral src={bottomRightCoral} alt="coral bottom" />
          <RightBottomFlower src={rightBottomFlower} alt="bottom flower" />
        </>
        {children}
      </BodyWrapper>
      <SettingsWrapper>
        <Settings />
      </SettingsWrapper>
      <MenuWrapper>
        <Menu />
      </MenuWrapper>
    </AppContainer>
  </>
}
